module.exports = __webpack_public_path__ + "img/rsps-list.cbb33cf0.png";